module.exports = __webpack_public_path__ + "img/cashier-pic-03.30245fee.png";